'use client'

import { useTranslation } from '@/hooks/client/use-translation'

import { useTooltipBubble } from './use-tooltip-bubble'

interface FormFactorTooltipProps {
  name: string
  description: string
}

export const FormFactorTooltip = ({ name, description }: FormFactorTooltipProps) => {
  const { t } = useTranslation()
  const { open, setOpen, ref, bubbleRef, alignClass } = useTooltipBubble()

  return (
    <span
      ref={ref}
      onPointerEnter={(event) => {
        if (event.pointerType === 'mouse') {
          setOpen(true)
        }
      }}
      onPointerLeave={(event) => {
        if (event.pointerType === 'mouse') {
          setOpen(false)
        }
      }}
      className="group relative inline-flex"
    >
      <button
        type="button"
        data-tracking="ignore"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className="text-navy decoration-navy/30 cursor-help text-left text-[0.95rem] leading-snug font-medium underline decoration-dotted underline-offset-4"
      >
        {name}
      </button>
      <span
        ref={bubbleRef}
        role="tooltip"
        className={`bg-navy pointer-events-none absolute bottom-full z-50 mb-2 w-64 rounded-xl px-4 py-3 text-left text-xs leading-relaxed font-normal whitespace-normal text-white shadow-lg transition-opacity ${alignClass} ${open ? 'pointer-events-auto opacity-100' : 'hidden'}`}
      >
        <span className="mb-1 block text-xs font-bold">{t('compare.formFactor', 'Form Factor')}</span>
        {description}
      </span>
    </span>
  )
}
